import { render } from "./ApeConstructorTraitInfo.vue?vue&type=template&id=24d724e1"
import script from "./ApeConstructorTraitInfo.vue?vue&type=script&lang=js"
export * from "./ApeConstructorTraitInfo.vue?vue&type=script&lang=js"

import "./ApeConstructorTraitInfo.vue?vue&type=style&index=0&id=24d724e1&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__